import React, { Component } from "react";

import { BottomBarItem } from './BottomBarItem/BottomBarItem'
import { LayoutContext } from "../../../modules/ContextModules/LayoutContext";
import "./BottomBar.css"

import measureImg from './.image/pen-ruler-solid@3x.png'
import tagImg from './.image/tag-solid@3x.png'
import printImg from './.image/print-solid@3x.png'
import locate from './.image/locate.png'

export class BottomBar extends Component {
    static contextType = LayoutContext;
    constructor(props) {
        super(props);

        this.state = {
            topbar: 1
        }

        this.buttonList = [
            { icon: measureImg, name: "測量工具" },
            { icon: tagImg, name: "標註功能" },
            { icon: printImg, name: "列印功能" },
            { icon: locate, name: "定位功能" },
        ]
    }

    render() {
        return (
            <div className="bottomBar">
                <div className="bottomBar__mark">
                    <div className="bottomBar__mark__inner">
                        <span>工具列</span>
                    </div>
                </div>
                <div className="bottomBar__list">
                    {
                        this.buttonList.map(item => {
                            return (
                                <BottomBarItem key={item.name} icon={item.icon} name={item.name} handleClick={this.handleClick} />
                            );
                        })
                    }
                </div>
            </div>
        );
    }

    handleClick = (event, name) => {
        (this.getClickHandles()[name])(event);
    }

    getClickHandles = () => ({
        測量工具: (event) => {
            // todo handle
            console.log("測量工具");
            this.context
                .draggableWindowContext
                .measureTool
                .update({
                    isOpened: true,
                    isMinimized: false
                });
        },
        標註功能: (event) => {
            // todo handle
            console.log("標註功能");
            this.context
                .draggableWindowContext
                .markFunction
                .update({
                    isOpened: true,
                    isMinimized: false
                });

        },
        列印功能: (event) => {
            // todo handle
            console.log("列印功能");
            this.context
                .draggableWindowContext
                .printFunction
                .update({
                    isOpened: true,
                    isMinimized: false
                });
        },
        定位功能: (event) => {
            // todo handle
            console.log("定位功能");
            this.context
                .draggableWindowContext
                .locateTool
                .update({
                    isOpened: true,
                    isMinimized: false
                });
        }
    })
}